let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6eTQ0")).then(() => parcelRequire('haqIx'));